import { render } from "./RoomControl.vue?vue&type=template&id=39d5eb9f&ts=true"
import script from "./RoomControl.vue?vue&type=script&lang=ts"
export * from "./RoomControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__